import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";


@Component({
  selector: 'app-admin-panel',
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.scss']
})
export class AdminPanelComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  category() {
    debugger;
    this.router.navigate(["home/adminpanel/category"]);
  }

  product() {
    debugger;
    this.router.navigate(["home/adminpanel/product"]);
  }

  subproduct() {
    debugger;
    this.router.navigate(["home/adminpanel/subproduct"]);
  }
}
